import DOMPurify from "dompurify";
import { marked } from "marked";
import TurndownService from "turndown";

marked.use({ breaks: true, gfm: true });

const turndown = new TurndownService({
  headingStyle: "atx",
  bulletListMarker: "-",
  emDelimiter: "*",
  strongDelimiter: "**",
});
turndown.addRule("lineBreak", { filter: ["br"], replacement: () => "\n" });

const ALLOWED = {
  ALLOWED_TAGS: [
    "p", "br", "b", "strong", "i", "em", "u", "s", "del", "code", "pre",
    "ul", "ol", "li", "h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "hr", "a", "div", "span",
    "table", "thead", "tbody", "tr", "th", "td",
  ],
  ALLOWED_ATTR: ["href", "target", "rel"],
};

export const sanitizeHtml = (html) => DOMPurify.sanitize(html || "", ALLOWED);

export const mdToHtml = (md) => sanitizeHtml(marked.parse(md || ""));

export const htmlToMd = (html) => {
  const clean = sanitizeHtml(html || "");
  return turndown.turndown(clean).replace(/\n{3,}/g, "\n\n").trim();
};

const MD_HINTS = [
  /(^|\n)[ \t]{0,3}#{1,6}[ \t]+\S/,
  /(^|\n)[ \t]{0,3}[-*+][ \t]+\S/,
  /(^|\n)[ \t]{0,3}\d+[.)][ \t]+\S/,
  /(^|\n)[ \t]{0,3}>[ \t]+\S/,
  /\*\*[^*\n]+\*\*/,
  /__[^_\n]+__/,
  /`[^`\n]+`/,
  /\[[^\]\n]+\]\([^)\s]+\)/,
];

/** Does this pasted text carry markdown worth turning into real formatting? */
export const looksMarkdown = (text) => MD_HINTS.some((r) => r.test(text || ""));

/** Markdown with the marks taken off — for one-line previews and titles. */export const mdToPlain = (md) =>
  (md || "")
    .replace(/`([^`]+)`/g, "$1")
    .replace(/\*\*(.+?)\*\*/g, "$1")
    .replace(/(^|\s)[*_](\S(?:.*?\S)?)[*_](?=\s|$)/g, "$1$2")
    .replace(/^\s{0,3}#{1,6}\s+/gm, "")
    .replace(/^\s*[-*+]\s+/gm, "• ")
    .replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, "$1")
    .trim();
